export default "__VITE_ASSET__0a0d00e1__"